import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {UserSessionService} from '../../shared/services/user-session.service';
import {AdminBarComponent} from '../admin-bar/admin-bar.component';
import {HeaderComponent} from '../header/header.component';
import {SidebarComponent} from '../sidebar/sidebar.component';
import {MainComponent} from '../main/main.component';
import {ModalComponent} from '../../components/views/modal/modal.component';

@Component({
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AdminBarComponent, HeaderComponent, SidebarComponent, MainComponent, ModalComponent]
})
export class MainLayoutComponent {
    private readonly userSessionService = inject(UserSessionService);

    readonly isAdmin = computed(() => this.userSessionService.userSession?.isAdmin ?? false);
}
